import { render, staticRenderFns } from "./AzLiveTopSlot.vue?vue&type=template&id=0a8fd734"
import script from "./AzLiveTopSlot.vue?vue&type=script&lang=js"
export * from "./AzLiveTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports